//=include  ../dataLayer.js
import DataLayer from '../dataLayer'
export default class HeaderTracker {


    constructor() {
        this.analytics = window.__pt.fn.analytics;
        this.settings = window.__pt.settings;
        this.events = window.__pt.fn.analytics.events;
    }

    metricLoginAction(fn, arg) {
        const { action } = arg;
        const objMetric = {
            event: this.events.gtmEvent,
            eventAction: action,
            eventCategory: "Login",
            eventName: "Login"
        }
        this.analytics.set(objMetric.event, objMetric);
    }


    metricHeaderSelectContent(arg) {
        const { title } = arg;
        const objMetric = {
            content_type: this.events.button,
            element: `header :: ${title}`,
            event: this.events.trackEvent,
            eventName: this.events.selectContent,
            layer: this.settings.page
        }
        this.analytics.set(objMetric.event, objMetric);
    }
    metricsErrorsLogin(key) {
        const objMetric = {
            event: this.events.gtmEvent,
            eventAction: "login error",
            eventCategory: "Login",
            eventName: "Login",
            eventLabel: `${key}`
        }
        this.analytics.set(objMetric.event, objMetric);
    }
}
